'use strict';

module.exports = {
  displayMessage: function (success, msg) {
    if (document.getElementById('alert-message')) {
      span.remove();
    }
    const span = document.createElement('DIV');
    span.classList.add('alert', 'card-custom', 'card-custom-plp', `${success ? 'custom-alert-success' : 'custom-alert-danger'}`);
    span.setAttribute('role', 'alert');
    span.setAttribute('aria-live', 'polite');
    span.setAttribute('id', 'alert-message');
    span.innerHTML = msg;
    document.querySelector('body').appendChild(span);

    setTimeout(function () {
      span.remove();
    }, 5000);
  },
};
